import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { withRouter } from 'react-router-dom';
import { asideMenuConfig, asideMenuConfig2, asideMenuConfig3, asideMenuConfig4 } from '@/menuConfig';
import styles from './index.module.scss';
import { withExpensePaymentMenu } from '../../../../pages/CompanyExpenseInvoice/paymentWorkflow.mjs';

// 按 allowedMenus (paths) 过滤一组菜单
const filterByAllowed = (cfg, allowed) => {
  if (!allowed || allowed.length === 0) return cfg;
  const set = new Set(allowed);
  const out = [];
  cfg.forEach((it) => {
    if (it.children && it.children.length > 0) {
      const kids = it.children.filter(k => set.has(k.path));
      if (kids.length > 0) out.push({ ...it, children: kids });
    } else if (set.has(it.path)) {
      out.push(it);
    }
  });
  return out;
};

// 把 menuConfig 变成 antd Menu items 格式
const toMenuItems = (cfg) =>
  (cfg || []).map(nav => {
    if (Array.isArray(nav.children) && nav.children.length > 0) {
      return {
        key: `group-${nav.name}`,
        label: nav.name,
        children: nav.children.map(sub => ({ key: sub.path, label: sub.name })),
      };
    }
    return { key: nav.path, label: nav.name };
  });

const Aside = (props) => {
  const { location, history } = props;
  const [items, setItems] = useState([]);

  useEffect(() => {
    const role = sessionStorage.getItem('userRole');
    const menuItems = config => toMenuItems(withExpensePaymentMenu(config, sessionStorage.getItem('userID')));
    // 超级管理员不受角色菜单白名单影响，管理员专属模块不能因误配角色而消失。
    if (role === '1' || role === '超级管理员') {
      setItems(menuItems(asideMenuConfig));
      return;
    }
    let allowed = null;
    try {
      const raw = sessionStorage.getItem('allowedMenus');
      if (raw) allowed = JSON.parse(raw);
    } catch (e) { allowed = null; }

    if (Array.isArray(allowed) && allowed.length > 0) {
      setItems(menuItems(filterByAllowed(asideMenuConfig, allowed)));
      return;
    }
    if (role === '4') setItems(menuItems(asideMenuConfig2));
    else if (role === '3') setItems(menuItems(asideMenuConfig3));
    else if (role === '5') setItems(menuItems(asideMenuConfig4));
    else                   setItems(menuItems(asideMenuConfig));
  }, []);

  // 当前路径所在分组 -> 默认展开
  const openKeys = items
    .filter(it => Array.isArray(it.children) && it.children.some(c => c.key === location.pathname))
    .map(it => it.key);

  return (
    <div className={styles.iceAsideCustom}>
      <Menu mode="inline" theme="light"
        selectedKeys={[location.pathname]}
        defaultOpenKeys={openKeys}
        items={items}
        onClick={({ key }) => { if (key && key.startsWith('/')) history.push(key); }}
        style={{ borderRight: 0 }}
      />
    </div>
  );
};

export default withRouter(Aside);
